
























import { Component, Prop, Vue } from 'nuxt-property-decorator'
import '~/assets/scss/v-tooltip.scss'
import { filterDateDM } from '~/assets/filters/date'

@Component({
  filters: {
    filterDateDM,
  },
})
export default class ComponentProductAvailable extends Vue {
  @Prop({ type: Boolean, default: false }) readonly available!: boolean
  @Prop({ type: Boolean, default: false }) readonly hasStores!: boolean
  @Prop({ type: Number, default: null }) readonly quantity!: number | null
  @Prop({ type: String, default: 'шт' }) readonly unit!: string
  @Prop({ type: String, default: null }) readonly availableDate!: string

  private clickAvailable() {
    if (this.hasStores) {
      this.$emit('click')
    }
  }
}
